export { PersistentStorageStrategyFactory } from './persistentFactory';
